// import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ExcelReports from './components/ExcelReports'
import Login from './components/Login'
import ProtectedRoute from './components/ProtectedRoute'
import './styles/layout.css'

function App() {
  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/report/:reportId" 
            element={
              <ProtectedRoute>
                <ExcelReports />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </Router>
  )
}

export default App 